import React from 'react';
import '../styles/MembershipOptions.css';

const MembershipOptions = ({ onSelectType }) => {
  return (
    <div className="membership-options">
      <div 
        className="option-card"
        onClick={() => onSelectType('lineal')}
      >
        <h3>Lineal Membership</h3>
        <p>Honoring the legacy of your WWII veteran ancestor by preserving their story for future generations</p>
      </div>
      
      <div 
        className="option-card"
        onClick={() => onSelectType('memorial')}
      >
        <h3>Memorial Membership</h3>
        <p>Pay tribute to a WWII veteran by ensuring their service and sacrifice are remembered</p>
      </div>
    </div>
  );
};

export default MembershipOptions; 